import { render, staticRenderFns } from "./CreateLessonHeader.vue?vue&type=template&id=61874d79&scoped=true&"
import script from "./CreateLessonHeader.vue?vue&type=script&lang=ts&"
export * from "./CreateLessonHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLessonHeader.vue?vue&type=style&index=0&id=61874d79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61874d79",
  null
  
)

export default component.exports